/**
 * The app's navigation, in one place.
 *
 * `Layout` renders this and `App` mounts a `<Route>` per entry, so the two
 * cannot disagree about what exists -- `routing.test.tsx` pins that. Adding a
 * page means adding one entry here and one `<Route>`; forgetting the route
 * gives a nav link that renders the not-found page, which is exactly what the
 * test catches.
 */
export interface NavEntry {
  to: string;
  label: string;
}

export const NAV: readonly NavEntry[] = [
  { to: "/", label: "Browse" },
  { to: "/saved", label: "Saved" },
  { to: "/dismissed", label: "Dismissed" },
  { to: "/patterns", label: "Patterns" },
  { to: "/audit", label: "Audit" },
];
